import { render, staticRenderFns } from "./DashboardPreview.vue?vue&type=template&id=0e516fbc&"
import script from "./DashboardPreview.vue?vue&type=script&lang=js&"
export * from "./DashboardPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports